import { getType, Reducer } from 'typesafe-actions'

import { DialogActions } from '../dialog'

import { UserActions } from './actions'
import { UserState } from './types'

export const initialState: UserState = {
  token: '',
  invalidContractDetected: false,
  invalidContractConfirmed: false,
  sessionTimeoutDetected: false,
  sessionTimeoutConfirmed: false
}

export const userReducer: Reducer<UserState, UserActions | DialogActions> = (state = initialState, action) => {
  switch (action.type) {
    case getType(UserActions.setToken):
      return {
        ...state,
        token: action.payload.token,
        invalidContractDetected: false,
        invalidContractConfirmed: false,
        sessionTimeoutDetected: false,
        sessionTimeoutConfirmed: false
      }
    case getType(UserActions.logout):
      return {
        ...state,
        invalidContractDetected: false,
        invalidContractConfirmed: false,
        sessionTimeoutDetected: false,
        sessionTimeoutConfirmed: false
      }
    case getType(UserActions.detectInvalidContract):
      return {
        ...state,
        token: '',
        invalidContractDetected: true,
        invalidContractConfirmed: false
      }
    case getType(UserActions.detectSessionTimeout):
      return {
        ...state,
        token: '',
        sessionTimeoutDetected: true,
        sessionTimeoutConfirmed: false
      }
    case getType(DialogActions.closeDialog):
      return {
        ...state,
        invalidContractConfirmed: state.invalidContractDetected ? true : state.invalidContractConfirmed,
        sessionTimeoutConfirmed: state.sessionTimeoutDetected ? true : state.sessionTimeoutConfirmed
      }
    default:
      return state
  }
}
